import { render, staticRenderFns } from "./RoomList.vue?vue&type=template&id=372e8d80"
import script from "./RoomList.vue?vue&type=script&lang=js"
export * from "./RoomList.vue?vue&type=script&lang=js"
import style0 from "./RoomList.vue?vue&type=style&index=0&id=372e8d80&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports